import { PAYEX_URL } from 'constants/config';
import type { Field } from 'models/field';
import type {
  GetOffersResponse,
  GetRecurrongOffersResponse,
} from 'models/offer';
import { fetch } from 'services/apiV3/fetch/fetch';

type GetAllOffersPayload = {
  amount: number;
  country: string;
  recipientId: string;
  fingerprint: string;
  locale: string;
  recurringConfigurationId: string;
  recipientFields: Field[];
};

type GetRecurringOffersPayload = {
  amount: number;
  country: string;
  recipientId: string;
  installments: number;
  recurringConfigurationId: string;
  fingerprint?: string;
  locale?: string;
  recipientFields: Field[];
};

export type OffersService = {
  getAll: (payload: GetAllOffersPayload) => Promise<GetOffersResponse>;
  getRecurringOffers: (
    payload: GetRecurringOffersPayload,
  ) => Promise<GetRecurrongOffersResponse>;
};

export const offers: OffersService = {
  getAll: ({
    amount,
    country,
    recipientId,
    fingerprint,
    locale,
    recurringConfigurationId,
    recipientFields,
  }) => {
    const path = `${PAYEX_URL}/offers`;
    const payload = {
      amount,
      country,
      recipient: recipientId,
      fingerprint,
      locale,
      ...(recurringConfigurationId && {
        recurring_configuration_id: recurringConfigurationId,
      }),
      ...(recipientFields.length ? { recipient_fields: recipientFields } : {}),
    };
    const options = {
      method: 'POST',
      body: JSON.stringify(payload),
    };

    return fetch(path, options);
  },
  getRecurringOffers: ({
    amount,
    country,
    installments,
    recipientId,
    fingerprint,
    locale,
    recurringConfigurationId,
    recipientFields,
  }) => {
    const path = `${PAYEX_URL}/offers/recurring`;
    const payload = {
      amount,
      country,
      recipient: recipientId,
      fingerprint,
      locale,
      installments,
      ...(recurringConfigurationId && {
        recurring_configuration_id: recurringConfigurationId,
      }),
      ...(recipientFields.length ? { recipient_fields: recipientFields } : {}),
    };
    const options = {
      method: 'POST',
      body: JSON.stringify(payload),
    };

    return fetch(path, options);
  },
};
